import { Component, inject, input } from '@angular/core';
import { TranslationService } from '@core/translation.service';
import { Customer } from '@features/customer/models/customer';
import { TranslateModule } from '@ngx-translate/core';
import { PnycIconComponent } from '@ui-kit/pnyc-icon/pnyc-icon.component';
import { locale } from './i18n/en';

@Component({
    selector: 'customer-short-info-card',
    templateUrl: './customer-short-info-card.component.html',
    styleUrls: ['./customer-short-info-card.component.scss'],
    imports: [
        PnycIconComponent,
        TranslateModule,
    ],
})
export class CustomerShortInfoCardComponent {
    public readonly customer = input.required<Customer>();

    translationLoaderService = inject(TranslationService);

    constructor() {
        this.translationLoaderService.loadTranslations(locale);
    }
}